<router-outlet></router-outlet>

<div class="mt container border">
  <span>About: <a href="https://github.com/Silverfeelin/AnimalWell-Helper">https://github.com/Silverfeelin/AnimalWell-Helper</a></span>
</div>

<div class="scroll-top border container" (click)="scrollTop()" title="Scroll to top">^</div>
